import Form, { style } from "element/form";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-password-reseted")
class CheckYourEmail extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <button class='${style.form__button}'>Continuar</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  [trait.onSubmit]() {
    location.assign("/oauth/sign-in");
    return this;
  }
}

export default CheckYourEmail;
